<template>
    <div class="top_tab" :style="style">
        <div class="btn">
            <img src="@/assets/imgs/icon19.png" alt="" @click="showSide = true">
        </div>
        <div class="icons">
            <span class="btn" @click="router.push('/')">
                <img src="@/assets/imgs/icon65.png" alt="">
            </span>
            <span class="btn" @click="router.push('/workbench/assets-lib/home')">
                <img src="@/assets/imgs/icon2.png" alt="">
            </span>
            <span class="btn">
                <img class="avatar"  :src="userInfo.avatar" v-if="userInfo.avatar" @click="showActionSheet = true" />
                <img  class="avatar" src="@/assets/imgs/icon1.png" v-else @click="router.push('/login')" />
            </span>
        </div>
    </div>
    <div class="wrapper" @click="showSide = false" v-show="showSide">
        <aside @click.stop="() => null">
            <img src="@/assets/imgs/logo.png" alt="" @click="router.push('/')"/>
            <ul class="tabs" @click="showSide = false">
                <li :class="{ active: route.path == '/workbench/personal/home' }"><router-link replace
                        to="/workbench/personal/home">个人中心</router-link></li>
                <li :class="{ active: route.path == '/workbench/personal/assets' }"><router-link replace
                        to="/workbench/personal/assets">数字资产</router-link> {{ data.myAssetNum }}</li>
                <li :class="{ active: route.path == '/workbench/personal/release' }"><router-link replace
                        to="/workbench/personal/release">我的发布</router-link> {{ data.myReleaseNum }}</li>
                <li :class="{ active: route.path == '/workbench/personal/collection' }"><router-link replace
                        to="/workbench/personal/collection">我的收藏</router-link> {{ data.favoriteCount }}</li>
                <li :class="{ active: route.path == '/workbench/personal/follow' }"><router-link replace
                        to="/workbench/personal/follow">我的关注</router-link> {{ data.followCount }}</li>
                <li :class="{ active: route.path == '/workbench/personal/order' }"><router-link replace
                        to="/workbench/personal/order">我的订单</router-link> </li>
                <li :class="{ active: route.path == '/workbench/personal/expense' }"><router-link replace
                        to="/workbench/personal/expense">收支明细</router-link> </li>
                <li @click="toHome"><router-link to="/">返回首页</router-link></li>
            </ul>
        </aside>
    </div>
    <van-action-sheet v-model:show="showActionSheet" :actions="actions" @select="onSelect" />

</template>
<script setup>
import { http } from '@/request/http'
import { onMounted, reactive, ref, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import cookie from 'cookie.js'
const props = defineProps({
    style: {
        type: Number,
        default: 0
    }
})
const router = useRouter(), route = useRoute()
const active = ref(0)
const showSide = ref(false)
const data = reactive({
    "myAssetNum": 33,
    "priceReleaseNum": 7,
    "myReleaseNum": 26,
    "favoriteCount": 7,
    "followCount": 1
})
onMounted(() => {
    http.get('/app-api/model/asset-tab-count/get-count').then(res => {
        Object.assign(data, res)
    })
})
const store = useStore()
const userInfo = computed(() => {
    return store.state.login.userInfo
})

const showActionSheet = ref(false)
const actions = [
    { name: '账户设置' },
    { name: '退出登录' }
];
const onSelect = (item) => {
    showActionSheet.value = false;
    if (item.name == '退出登录') {
        logout()
    }
    if (item.name == '账户设置') {
        router.push('/workbench/personal/account')
    }
};

const logout = () => {
    cookie.remove('accessToken', {path: '/'})
    cookie.remove('tenantId', {path: '/'})
    if(route.path.startsWith('/workbench')){
        router.replace('/')
    }
    setTimeout(() => {
        location.reload()
    }, 0)
}
</script>
<style scoped lang="scss">
.top_tab {
    padding: 0 10rem;
    display: flex;
    justify-content: space-between;
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: #fff;
}

.icons {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60rem;
}

.btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60rem;
    width: 35rem;
    .avatar{
        border-radius: 50%;
    }
    img {
        width: 24rem;
        height: 24rem;

    }
}

.wrapper {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
}

aside {
    width: 150rem;
    height: 100vh;
    background-color: #fff;
    position: absolute;
    left: 0;
    top: 0;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    transition: all 1s ease-in-out;

    img {
        width: 85rem;
        margin: 0 33rem;
    }

    ul {
        li {
            height: 48rem;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14rem;
            color: #8A8A8A;
            a {
                color: #8A8A8A; margin-right: 10rem;
            }
        }

        .active {
            background-color: #F7F7F9;color: #000;
            a{color: #000;}
        }
    }
}
</style>